import React from "react";
import { siteConfig as fallback } from "../mock";
import { useSite } from "../context/SiteContext";

const HowToOrder = () => {
  const { settings } = useSite();
  const steps = settings?.howToOrder || fallback.howToOrder;
  return (
    <section id="how" className="bg-navy py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="reveal text-center max-w-2xl mx-auto mb-16">
          <p className="text-gold text-sm font-semibold tracking-widest uppercase mb-3">Simple &amp; Fast</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white">How To Order</h2>
        </div>
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4 relative">
          {steps.map((s, idx) => (
            <div key={idx} className="reveal relative" style={{ transitionDelay: `${idx * 60}ms` }}>
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-[60%] w-full h-px bg-gradient-to-r from-gold/40 to-transparent" />
              )}
              <div className="relative z-10 h-16 w-16 rounded-2xl bg-navy-800 gold-border flex items-center justify-center mb-5">
                <span className="gold-gradient-text font-display font-extrabold text-2xl">{s.step || idx + 1}</span>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">{s.title}</h3>
              <p className="text-slate-400 text-sm leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowToOrder;
